import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionType } from 'utils/constants';

import utils from 'utils';
import actions from 'state/actions';

import CommonButton from 'components/Buttons/CommonButton';
import selectors from 'state/selectors';
import { GetNopoMicrocategoriesResponse, GetNopoVendorResponse } from 'models/response';

const Add = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const editedRowId = useSelector(selectors.configurator.getNOPOEditedRowId);
  const rows = useSelector(selectors.configurator.getNOPOLeftTableRows);
  const selectedTable = useSelector(selectors.configurator.selectTableToSearch);
  const selectedRow = useSelector(selectors.configurator.getSelectedRow);
  const addRow = async () => {
    let row: GetNopoVendorResponse | GetNopoMicrocategoriesResponse;
    if (selectedTable === 'microcategory') {
      row = {
        id: '-1',
        companyName: '',
        ap2Template: false,
        definitionForAnomalies: '',
        fluxName: '',
        idAction: -1,
        idCompany: -1,
        microcategoryCode: '',
        microcategoryDescription: '',
        wfCausal: '',
        wfIdCausal: -1,
        wfIdWorkflowDefinition: -1,
        workflowDefinition: '',
        microcategoryDetails: [],
      } as GetNopoMicrocategoriesResponse;
    } else {
      row = {
        id: '-1',
        idAction: -1,
        idCompany: -1,
        companyName: '', // company
        supplierCode: '',
        subjectName: '', // subject
        wfIdCausal: -1,
        wfCausal: '', // casuals
        ap2Template: false,
        wfIdWorkflowDefinition: -1,
        workflowDefinition: '', // definition
        fluxName: '', // flux
        vendorDetails: [],
      };
    }

    dispatch(
      actions.configurator.setNoPoLeftTableRows([row, ...rows] as
        | GetNopoMicrocategoriesResponse[]
        | GetNopoVendorResponse[]),
    );
    dispatch(actions.configurator.setNoPoEditedRowId('-1'));
    dispatch(actions.app.setDisabledDropdown(true));
    return;
  };

  return (
    <CommonButton
      id="add-row-action-table"
      action={addRow}
      scope="tertiary"
      value={t('nopoAddActionTable')}
      customIcon="plus"
      disabled={
        editedRowId !== undefined ||
        !utils.user.isActionByCompanyActive(actionType.ACTION_TABLE_ADD_ROW, selectedRow?.companyName)
      }
    />
  );
};

export default Add;
